import { render, staticRenderFns } from "./TopPreview.vue?vue&type=template&id=23530baa&"
import script from "./TopPreview.vue?vue&type=script&lang=js&"
export * from "./TopPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports